
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import * as d3 from "d3";
import * as $ from "jquery";

import { AvailabilityExplorerController } from "../ts/rlAdmin.controllers";
import { IAvailsTimelineAssetsRightsGroup } from "../ts/rlAdmin.models";

export function RLAvailExplorerChart() {
    var directive: ng.IDirective = {
        require: "^ngController",
        template: require("/assets/app/templates/avail-explorer-chart.html"),
        controller: RLAvailExplorerChartController,
        controllerAs: "aecVM",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: AvailabilityExplorerController) => {

            // setup d3 chart
            var chart = new RLAvailChart(element[0], controller);

            // update/resize whenever controller data changes
            scope.$watchCollection(() => [controller.assetData, controller.summaryData], (newValue, oldValue) => {
                if (newValue != oldValue) {
                    chart.UpdateData(controller.filterModel.startDate, controller.filterModel.endDate, controller.assetData, controller.summaryData);
                    chart.Render();
                    chart.Resize();
                }
            });

            //scope.$watch(() => $(element[0]).innerWidth(),
            //    (newValue, oldValue) => {
            //        if (newValue != oldValue) {
            //            chart.Render();
            //        }
            //    });

            // re-render chart whenever show options are changed
            scope.$watch(() => controller.filterModel.show,
                (newValue, oldValue) => {
                    if (newValue != oldValue) {
                        chart.Render();
                    }
                }, true);
        }
    };
    return directive;
}

class RLAvailExplorerChartController {
    static $inject = [];

    constructor() {

    }
}

class RLAvailChart {

    assetData: Models.IAvailsTimelineAssetsRightsGroup[];                      // asset+ associate rightset collections
    summaryData: Models.IAvailsTimelineSummaryWindow[];       // summary window data

    width: number;                                              // overall width of chart
    tickTextHeight: number = 14;                                // height of scale labels
    margin = { top: 25, right: 10, left: 0, bottom: 10 };       // margins on chart (not used)
    dealMarginWidth = 200;                                      // width of title boxes to left
    barHeight = 20;                                             // height of typical rightset box/aggregate summary bar
    summaryBarHeight = 5;                                       // height of summary bar for individual summary bar

    minMoment: moment.Moment;                                          // min date as moment
    maxMoment: moment.Moment;                                          // max date as moment

    startMoment: moment.Moment;                                        // start date as moment
    endMoment: moment.Moment;                                          // end date as moment

    timeScaleUnclamped: d3.time.Scale<number, number>;                     // time scale 
    timeScale: d3.time.Scale<number, number>;                              // time scale clamped to start/end date
    container: d3.Selection<any>;                                    // container of outer directive <div rl-avail-explorer-chart=''... />
    chartContainer: d3.Selection<any>;                               // container of <div class='chart'.. />
    tooltip: d3.Selection<any>;                                      // element of <div class="chart-tooltip" />

    tooltipPosition: { top: number; left: number; } = { top: 20, left: 20 };

    primaryTicks: any[];                                        // ticks of larger timescale (typically year)
    secondaryTicks: any[];                                      // ticks of smaller timescale (typcially month)

    // lookup to determine level number of a rightset under an assetID
    levelDictionary: { [assetID: number]: { [rightSetID: number]: number } } = {};
    // total number of levels per assetID
    levelCount: { [assetID: number]: number } = {};

    assetRowHeights: number[];
    assetRowOffsets: number[];
    assetRowIndexLookup: { [hashId: number]: number };
    fullRowsHeight: number;

    // calculate height of each <svg class="asset-row" />
    heightOfRowSvg = (availAsset: Models.IAvailsTimelineAssetsRightsGroup) => {
        return (this.barHeight * 2) + this.summaryBarHeight + ((1.5 * this.levelCount[availAsset.assetIDsHash] + .5) * this.barHeight)
    };

    // calculate height of <rect class="asset-rect" .. ></rect>
    heightOfAssetRectSvg = (availAsset: Models.IAvailsTimelineAssetsRightsGroup) => {
        return this.heightOfRowSvg(availAsset) - this.barHeight;
    };

    // calculate height of each rightset's <rect class="shadow" ...></rect>
    heightOfRowShadow = (level: number) => {
        return (this.barHeight) + ((this.barHeight * 1.5) * level);
    };

    // convert start string  date to moment
    toStartMoment = (dateString: string) => {
        return moment(new Date(dateString)).startOf("day");
    };

    // convert string date to Date
    toStartDate = (dateString: string) => {
        return this.toStartMoment(dateString).toDate();
    };

    // convert end string date to moment  (sets time to end of day)
    toEndMoment = (dateString: string) => {
        return moment(new Date(dateString)).endOf("day");
    };

    // convert end string date to Date (sets time to end of day)
    toEndDate = (dateString: string) => {
        return this.toEndMoment(dateString).toDate();
    };

    getAssetsTitle = (availAsset: Models.IAvailsTimelineAssetsRightsGroup) => {
        var keys = _.keys(availAsset.assets).map(k => _.parseInt(k));
        return `${availAsset.assets[_.min(keys)]}`;
    };


    // determine whether to show secondary ticks based on time resolution
    showSecondaryTicks: boolean;

    zoom: d3.behavior.Zoom<Date>;

    scaleLevel: number;

    //colorScale: D3.Scale.OrdinalScale;
    startDateDictionary: { [rightSetID: number]: Date };
    overrunStartDateDictionary: { [rightSetID: number]: Date };
    endDateDictionary: { [rightSetID: number]: Date };

    initialized: boolean;

    scrollPosition: number;

    constructor(containerElement: HTMLElement, private ctrl: AvailabilityExplorerController) {

        // initialize data
        this.assetData = [];
        this.summaryData = [];
        this.primaryTicks = [];
        this.secondaryTicks = [];

        // find outer most container elements
        this.container = d3.select(containerElement);
        this.chartContainer = d3.select($(containerElement).find(".chart")[0]);
        this.tooltip = d3.select($(containerElement).find(".chart-tooltip")[0]);

        // calculate width of chartContainer
        this.width = $(this.chartContainer.node()).innerWidth();

        // setup timescales (set range, domain will come later)
        this.timeScaleUnclamped = d3.time.scale<number>().range([0, this.width - this.dealMarginWidth]);
        this.timeScale = this.timeScaleUnclamped.copy().clamp(true);

        //this.colorScale = d3.scale.category20();
        //this.colorScale.range().unshift("#3c3d3a");  // add the main black as the first type

        this.initialized = false;

        this.scrollPosition = 0;

        // whenever window changes size, recalculate layout and redraw
        window.onresize = (e: UIEvent) => {
            if (this.initialized) {
                this.Resize();
            }
        };

        var scrolledDiv = this.chartContainer.select("div.asset-rows");

        var debouncedRerender = _.debounce(() => {
            this.scrollPosition = $(scrolledDiv[0]).scrollTop();
            this.tooltip.style("visibility", "hidden");
            // render the rows
            this.RenderRows();

        }, 500, { maxWait: 500 });

        scrolledDiv.on("scroll", (d, i) => {
            debouncedRerender();
        });


        this.zoom = d3.behavior.zoom<Date>()
            .on("zoom", () => {
                this.Zoomed();
            })
            .x(<d3.behavior.zoom.Scale><any>this.timeScaleUnclamped);

        this.chartContainer.select("svg.header rect.window-pane").call(this.zoom);
        this.chartContainer.select("svg.footer rect.window-pane").call(this.zoom);

        this.tooltip.selectAll(".close").on("click", (event: Event) => {

            return this.CloseToolTip();
        });




        this.tooltip.select(".rl-panel-header-move")
            .on("mousedown", () => {
                (<Event>d3.event).preventDefault();
                var lastPos = d3.mouse(this.container.node());

                this.tooltip.on("mousemove", () => {
                    var pos = d3.mouse(this.container.node());
                    var delta = [pos[0] - lastPos[0], pos[1] - lastPos[1]];
                    lastPos = pos;
                    this.tooltipPosition.top += delta[1];
                    this.tooltipPosition.left += delta[0];
                    return this.SetToolTipPosition();
                });
            })

        d3.select(document)
            .on("mouseup", () => {
                this.tooltip.on("mousemove", null);
            });
    }


    Zoomed() {

        var self = this;

        var rowsSVG = this.chartContainer.select("div.asset-rows svg.asset-rows-svg");
        var scaleG = rowsSVG.select("g.scale");
        var rowsDefs = rowsSVG.select("defs");

        // update range of timescales to new width
        this.timeScale = this.timeScaleUnclamped.copy().clamp(true);

        // update scale ticks
        this.CalculateScales();

        //this.Render();

        // render header
        this.RenderHeader();
        // update scale
        this.RenderScale(scaleG, "rows");
        // update search window zone
        this.RenderSearchWindowZone(scaleG, "rows", rowsDefs);

        rowsSVG.selectAll(".asset-row rect.box")
            .each(function (d: Models.IAvailsTimelineGroupRightset, i: number) {
                var rect = d3.select(this);

                var startDateX = self.timeScale(self.startDateDictionary[d.rightsetID]);
                var endDateX = self.timeScale(self.endDateDictionary[d.rightsetID]);

                var translate = d3.transform(rect.attr("transform")).translate;
                rect.attr("width", endDateX - startDateX)
                    .attr("transform", "translate(" + startDateX + "," + translate[1] + ")");

            });

        rowsSVG.selectAll(".asset-row rect.overrun")
            .each(function (d: Models.IAvailsTimelineGroupRightset, i: number) {
                var rect = d3.select(this);

                var startDateX = self.timeScale(self.overrunStartDateDictionary[d.rightsetID] || self.endDateDictionary[d.rightsetID]);
                var endDateX = self.timeScale(self.endDateDictionary[d.rightsetID]);

                var translate = d3.transform(rect.attr("transform")).translate;
                rect.attr("width", endDateX - startDateX)
                    .attr("transform", "translate(" + startDateX + "," + translate[1] + ")");

            });

        rowsSVG.selectAll(".asset-row .right-title-fo")
            .each(function (d: Models.IAvailsTimelineGroupRightset, i: number) {
                var foreignObject = d3.select(this);

                var startDateX = self.timeScale(self.startDateDictionary[d.rightsetID]);
                var endDateX = self.timeScale(self.endDateDictionary[d.rightsetID]);

                var translate = d3.transform(foreignObject.attr("transform")).translate;
                foreignObject.attr("width", endDateX - startDateX)
                    .attr("transform", "translate(" + startDateX + "," + translate[1] + ")");
            });

        rowsSVG.selectAll(".asset-row g.asset-data g.asset-summary-bar rect")
            .each(function (d: Models.IAvailsTimelineGroupWindow, i: number) {
                var rect = d3.select(this);

                var startDate = self.toStartDate(d.windowStart);
                var endDate = self.toEndDate(d.windowEnd);

                var startDateX = self.timeScale(startDate);
                var endDateX = self.timeScale(endDate);

                rect
                    .attr("width", (d: Models.IAvailsTimelineGroupWindow) => endDateX - startDateX)
                    .attr("transform", (d: Models.IAvailsTimelineGroupWindow) => "translate(" + startDateX + ",0)");
            });

        this.RenderFooter();
    }


    /*
     * Recalculate the size of the chart and re-render the chart
     */
    Resize() {

        // let the parent container get it's natural width again

        // lock current height of <div class='chart' /> (keeps browser scroll bar from disappearing and changing the width
        this.chartContainer.style("height", $(this.chartContainer.node()).height() + "px");

        // hide all svgs (so the <div class='chart' /> can take it's natural width)
        this.chartContainer.selectAll("svg").style({ display: "none" });

        // get the new width of <div class='chart' />
        this.width = $(this.chartContainer.node()).innerWidth();

        // show all the svgs again
        this.chartContainer.selectAll("svg").style({ display: "" });
        // unlock the height of <div class='chart' />
        this.chartContainer.style("height", null);

        // update range of timescales to new width
        this.timeScaleUnclamped = this.timeScaleUnclamped.range([0, this.width - this.dealMarginWidth]);
        this.timeScale = this.timeScaleUnclamped.copy().clamp(true);

        // update scale ticks
        this.CalculateScales();

        // set new width on non-data driven elements
        this.chartContainer.select("svg.header").attr({ width: this.width });
        this.chartContainer.selectAll("svg.header g.scale .scale-horizontal").attr({ x2: this.width });

        this.chartContainer.select("svg.footer").attr({ width: this.width });
        this.chartContainer.selectAll("svg.footer g.scale .scale-horizontal").attr({ x2: this.width });

        // render data again
        this.Render();
    }

    /*
     * Updates the data with new time range and result values
     * This does not re-render, call that separately
     */
    UpdateData(startDate: string, endDate: string, assetData: Models.IAvailsTimelineAssetsRightsGroup[], summaryData: Models.IAvailsTimelineSummaryWindow[]) {
        this.assetData = assetData;
        this.summaryData = summaryData;

        this.startMoment = moment(startDate, this.ctrl.dateLocaleService.getDateFormat()).startOf("day");

        this.endMoment = moment(endDate, this.ctrl.dateLocaleService.getDateFormat()).endOf("day");

        var fivePercent = { seconds: Math.abs(this.endMoment.unix() - this.startMoment.unix()) * 0.05 };

        this.minMoment = this.startMoment.clone().subtract(fivePercent);
        this.maxMoment = this.endMoment.clone().add(fivePercent);

        // update domains of time scales (range only changes when the width does)
        this.timeScaleUnclamped.domain([this.minMoment.toDate(), this.maxMoment.toDate()]);
        this.timeScale.domain([this.minMoment.toDate(), this.maxMoment.toDate()]);

        this.zoom.x(<d3.behavior.zoom.Scale><any>this.timeScaleUnclamped);

        // update scale ticks
        this.CalculateScales();

        // precalculate start/end dates for zooming callbacks
        this.startDateDictionary = {};
        this.overrunStartDateDictionary = {};
        this.endDateDictionary = {};

        this.assetData.forEach((asset) => {
            asset.rightsets.forEach((rs) => {
                this.startDateDictionary[rs.rightsetID] = this.toStartDate(rs.startDate);
                if (rs.overrunStartDate != null) {
                    this.overrunStartDateDictionary[rs.rightsetID] = this.toStartDate(rs.overrunStartDate);
                }
                this.endDateDictionary[rs.rightsetID] = this.toEndDate(rs.endDate);
            });
        });

        this.scrollPosition = 0;
    }

    CalculateLevels() {

        /* calculate rightset levels */
        this.levelDictionary = {};
        this.levelCount = {};

        /* for each asset, organize its rightsets into levels such that no rightset overlaps another on the same level */
        this.assetData.forEach((a) => {
            this.levelDictionary[a.assetIDsHash] = {};
            var levels: Models.IAvailsTimelineGroupRightset[][] = [[]];
            a.rightsets.forEach((rs) => {
                var i = 0;
                while (levels[i]) {
                    var overlap = _.any(levels[i], (rs2) => (rs.startDate < rs2.endDate && rs2.startDate < rs.endDate) || (rs.startDate == rs2.startDate || rs.endDate == rs2.endDate));
                    if (!overlap) {
                        // if no conflicts, push to current level
                        levels[i].push(rs);
                        return false;
                    } else if (i + 1 == levels.length) {
                        // if conflict and last level, add a new level
                        levels.push([]);
                    }
                    // next level
                    i++;
                }
            });

            // enter the resulting level indexing into a lookup object for [asset][rightset]:[levelIndex]
            levels.forEach((level, levelIndex) => {
                level.forEach((rs) => {
                    this.levelDictionary[a.assetIDsHash][rs.rightsetID] = levelIndex;
                });
            });

            // get the total count of levels for the asset
            this.levelCount[a.assetIDsHash] = levels.length;
        });

    }

    CalculateRowHeights() {
        this.assetRowHeights = [];
        this.assetRowOffsets = [];
        this.assetRowIndexLookup = {};

        var total = 0;
        this.assetData.forEach((assetData, i) => {
            var rowHeight = this.heightOfRowSvg(assetData);
            this.assetRowIndexLookup[assetData.assetIDsHash] = i;
            this.assetRowHeights[i] = rowHeight;
            this.assetRowOffsets[i] = total;

            total += rowHeight;
        });

        this.fullRowsHeight = _.reduce(this.assetRowHeights, (sum: number, num: number) => sum + num);
    }

    /*
     * Calculate the Primary/Secondary ticks based on current width/time range
     */
    CalculateScales() {

        var minValue = this.timeScale.domain()[0];
        var maxValue = this.timeScale.domain()[1];
        var minMoment = moment(minValue);
        var maxMoment = moment(maxValue);

        this.scaleLevel = 1;
        var primaryTickStep = d3.time.year;
        var secondaryTickStep = d3.time.month;

        if (this.timeScale.ticks(secondaryTickStep, 0).length < 6) {
            this.scaleLevel = 2;
            primaryTickStep = d3.time.month;
            secondaryTickStep = d3.time.day;
        }

        // get the ticks for years,
        var primaryTickCollection = this.timeScale.ticks(primaryTickStep, 0);

        // get the ticks for months
        var secondaryTickCollection = this.timeScale.ticks(secondaryTickStep, 0);

        if (this.scaleLevel == 1) {
            // ensure first year is included
            if (!_.any(primaryTickCollection, (tick) => moment(tick).year() == minMoment.year())) {
                primaryTickCollection.unshift(minValue);
            }
            // ensure last year is included
            if (!_.any(primaryTickCollection, (tick) => moment(tick).year() == maxMoment.year())) {
                primaryTickCollection.push(maxValue);
            }

            //ensure first month is included
            if (!_.any(secondaryTickCollection, (tick) => moment(tick).year() == minMoment.year() && moment(tick).month() == minMoment.month())) {
                secondaryTickCollection.unshift(minValue);
            }
        } else if (this.scaleLevel == 2) {

            // ensure first month is included
            if (!_.any(primaryTickCollection, (tick) => moment(tick).year() == minMoment.year() && moment(tick).month() == minMoment.month())) {
                primaryTickCollection.unshift(minValue);
            }
            // ensure last month is included
            if (!_.any(primaryTickCollection, (tick) => moment(tick).year() == maxMoment.year() && moment(tick).month() == maxMoment.month())) {
                primaryTickCollection.push(maxValue);
            }

            //ensure first day is included
            if (!_.any(secondaryTickCollection, (tick) => moment(tick).year() == minMoment.year() && moment(tick).month() == minMoment.month() && moment(tick).date() == minMoment.date())) {
                secondaryTickCollection.unshift(minValue);
            }
        }

        // only show secondary ticks when the tick width > 20px
        this.showSecondaryTicks = ((this.width - this.dealMarginWidth) / secondaryTickCollection.length) > 20;


        this.primaryTicks = primaryTickCollection;
        this.secondaryTicks = secondaryTickCollection;
    }

    /*
     * Renders the inner data
     */
    Render() {

        // extra this reference for non-arrow functions
        var self = this;

        // render the header
        this.RenderHeader();
        // render the footer
        this.RenderFooter();
        // calculate new level layouts
        this.CalculateLevels();
        // calculate heights of each row
        this.CalculateRowHeights();
        // render the rows
        this.RenderRows();

        this.initialized = true;
    }

    RenderRows() {

        var viewWindow: [number, number] = [this.scrollPosition - 500, this.scrollPosition + 1000];

        var self = this;

        var rowsSVG = this.chartContainer.select("div.asset-rows svg.asset-rows-svg").attr({ width: this.width, height: this.fullRowsHeight });
        var rowsDefs = rowsSVG.select("defs");

        /* filter the asset data groups by those who's "rectangle"
            is within 500px of the scrolled viewport.
         */
        var viewFilteredAssetData = this.assetData
            .filter((arg, i) => {
                var index = this.assetRowIndexLookup[arg.assetIDsHash];
                var assetDataWindow: [number, number] = [this.assetRowOffsets[index], this.assetRowOffsets[index] + this.assetRowHeights[index]];

                // overlap algorithm
                return (assetDataWindow[0] < viewWindow[1] && viewWindow[0] < assetDataWindow[1]) || (assetDataWindow[0] == viewWindow[0] || assetDataWindow[1] == viewWindow[1]);
            });

        /* rows for each title data
         * data is unique by it's assetRecID
        */
        var rowRectData = rowsSVG
            .select("g.rects")
            .selectAll("rect.asset-rect")
            .data(viewFilteredAssetData, (d: Models.IAvailsTimelineAssetsRightsGroup): string => d.assetIDsHash.toString());

        /* ENTER append gray background rect.asset-rect */
        rowRectData.enter()
            .append("rect")
            .classed("asset-rect", true);

        /* UPDATE adjust the gray background rect.asset-rect */
        rowRectData
            .attr("width", () => this.width)
            .attr("height", (d: Models.IAvailsTimelineAssetsRightsGroup) => {
                return this.heightOfAssetRectSvg(d);
            })
            .attr("transform", (d: Models.IAvailsTimelineAssetsRightsGroup, i: number) => {
                //return i == 0 ? "translate(0," + this.barHeight / 2 + ")" : "translate(0," + (_.reduce(this.assetRowHeights.slice(0, i), (sum: number, num: number) => sum + num) + (this.barHeight / 2)) + ")";
                var index = this.assetRowIndexLookup[d.assetIDsHash];

                return "translate(0," + (this.assetRowOffsets[index] + (this.barHeight / 2)) + ")";
            });

        // EXIT: remove rect when data exits
        rowRectData.exit().remove();

        var scaleG = rowsSVG.select("g.scale").attr("transform", "translate(" + this.dealMarginWidth + ", 0)");

        this.RenderScale(scaleG, "rows");
        this.RenderSearchWindowZone(rowsSVG.select("g.scale"), "rows", rowsDefs);


        /* rows for each title data
         * data is unique by it's assetRecID
        */
        var rowGData = rowsSVG
            .selectAll("g.asset-row")
            .data(viewFilteredAssetData, (d: Models.IAvailsTimelineAssetsRightsGroup) => d.assetIDsHash.toString());

        // ENTER: when data enters, append g.asset-row
        rowGData.enter()
            .append("g")
            .classed("asset-row", true)
            .call((g) => {

                // append html info box on left
                g.append("g")
                    .classed("asset-info", true)
                    .append("foreignObject")
                    .classed("asset-title-fo", true)
                    .call((fo) => {
                        fo.append("xhtml:div").call((div) => {
                            div.append("div").classed("asset-title", true);
                            div.append("span").classed("deal-count", true);
                            div.append("span").classed("assets-count", true);
                        });
                    });
                // append g.asset-data
                g.append("g")
                    .classed("asset-data", true)
                    .call((g) => {
                        //// g.asset-shadows for shadows
                        //g.append("g").classed("asset-shadows", true);
                        // g.asset-boxes for rightset boxes
                        g.append("g").classed("asset-boxes", true);
                        // g.asset-box-texts for rightset texts
                        g.append("g").classed("asset-box-texts", true);
                        // g.asset-summary-bar for summary bar
                        g.append("g").classed("asset-summary-bar", true).attr("transform", "translate(0," + this.barHeight / 2 + ")");
                    });
            });

        // EXIT: remove rows when data exits
        rowGData.exit().remove();


        //// UPDATE set Y translate of each g.asset-row
        rowGData
            .attr("transform", (d: Models.IAvailsTimelineAssetsRightsGroup, i: number) => {
                //return i == 0 ? "translate(0,0)" : "translate(0," + _.reduce(this.assetRowHeights.slice(0, i), (sum: number, num: number) => sum + num) + ")";

                var index = this.assetRowIndexLookup[d.assetIDsHash];

                return "translate(0, " + this.assetRowOffsets[index] + ")";
            });
        //.attr("width", () => this.width)
        //.attr("height", (d: Models.IAvailSearchAsset) => {
        //    return this.heightOfRowSvg(d);
        //});


        /* UPDATE adjust height of asset info box, set the text values */
        rowGData
            .select("g.asset-info .asset-title-fo")
            .attr({ x: 0, y: this.barHeight / 2, width: this.dealMarginWidth })
            .attr("height", (d: Models.IAvailsTimelineAssetsRightsGroup) => {
                return this.heightOfAssetRectSvg(d);
            })
            .call((g) => {
                g.select(".asset-title")
                    .attr("title", (d: Models.IAvailsTimelineAssetsRightsGroup) => self.getAssetsTitle(d))
                    .text((d: Models.IAvailsTimelineAssetsRightsGroup) => self.getAssetsTitle(d));
                g.select(".deal-count")
                    .text((d: Models.IAvailsTimelineAssetsRightsGroup) => {
                        var dealIDs = _.uniq(d.rightsets.map(rs => rs.dealID));

                        if (dealIDs.length == 1) {
                            return "1 Deal";
                        } else {
                            return dealIDs.length + " Deals";
                        }
                    });
                g.select(".assets-count")
                    .style("visibility", (d: Models.IAvailsTimelineAssetsRightsGroup) => {
                        var count = _.keys(d.assets).length;
                        return count > 1 ? "visible" : "hidden";
                    })
                    .text((d: Models.IAvailsTimelineAssetsRightsGroup) => {
                        var count = _.keys(d.assets).length;
                        return `${count} included Titles`;
                    });
            });

        /* UPDATE adjust postion of g.asset-data */
        rowGData.select("g.asset-data")
            .attr("transform", "translate(" + this.dealMarginWidth + ", " + this.barHeight / 2 + ")");


        /* UPDATE adjust asset row summary bar,  data unique by summar window start date */
        var assetSummaryBarsData = rowGData.select("g.asset-data g.asset-summary-bar")
            .selectAll("rect")
            .data((d: Models.IAvailsTimelineAssetsRightsGroup) => d.windows, (d: Models.IAvailsTimelineGroupWindow) => d.windowStart);

        /* ENTER appent a rect per each summary window */
        assetSummaryBarsData.enter()
            .append("rect");

        /* EXIT remove summary bar */
        assetSummaryBarsData.exit().remove();

        /* UPDATE set class of rect depending on availability percentage, adjust width/position */
        assetSummaryBarsData
            .attr("class", (d: Models.IAvailsTimelineGroupWindow) => {
                if (d.percentAvailable <= 0) {
                    return "unavailable";
                } else if (d.percentAvailable >= 1) {
                    return "available";
                } else {
                    return "partial";
                }
            })
            .attr("height", this.summaryBarHeight)
            .attr("width", (d: Models.IAvailsTimelineGroupWindow) => this.timeScale(this.toEndDate(d.windowEnd)) - this.timeScale(this.toStartDate(d.windowStart)))
            .attr("transform", (d: Models.IAvailsTimelineGroupWindow) => "translate(" + this.timeScale(this.toStartDate(d.windowStart)) + ",0)");


        ///* UPDATE shadows for each rightset box, data unique by rightSetID */
        //var shadowsData = rowGData.select("g.asset-data g.asset-shadows")
        //    .attr("transform", "translate(0," + (this.barHeight / 2 + this.summaryBarHeight) + ")")
        //    .selectAll("rect.shadow")
        //    .data((d: Models.IAvailSearchAsset) => d.assetRightSets, (d: Models.IAvailSearchAssetRightSet) => d.rightSetID);

        ///* ENTER append rec.shadow */
        //shadowsData.enter()
        //    .append("rect")
        //    .classed("shadow", true);

        ///* EXIT remove rect.shadow */
        //shadowsData.exit().remove();

        ///* UPDATE adjust height/position of shadow boxes */
        //shadowsData
        //    .attr("height", function (d: Models.IAvailSearchAssetRightSet) {
        //        var selection = d3.select(this); // this is the contextually bound this <rect />
        //        var assetData = <Models.IAvailSearchAsset> d3.select(selection.node().parentNode).datum();  // grab parent data
        //        var level = self.levelDictionary[assetData.assetRecID][d.rightSetID];
        //        return self.heightOfRowShadow(level);
        //    })
        //    .attr("width", (d: Models.IAvailSearchAssetRightSet) => this.timeScale(this.toEndDate(d.endDate)) - this.timeScale(this.toStartDate(d.startDate)))
        //    .attr("transform", (d: Models.IAvailSearchAssetRightSet) => "translate(" + this.timeScale(this.toStartDate(d.startDate)) + ",0)");

        /* UPDATE boxes for rightsets, data unique by righSetID */
        var boxesData = rowGData.select("g.asset-data g.asset-boxes")
            .attr("transform", "translate(0," + (this.barHeight / 2 + this.summaryBarHeight) + ")")
            .selectAll("rect.box")
            .data((d: Models.IAvailsTimelineAssetsRightsGroup) => d.rightsets, (d: Models.IAvailsTimelineGroupRightset) => d.rightsetID.toString());

        /* ENTER append rect.box */
        boxesData.enter()
            .append("rect")
            .classed("box", true);
       
        /* EXIT remove rect.box */
        boxesData.exit().remove();

        /* UPDATE adjust height/position of rect.box */
        boxesData
            .attr("height", this.barHeight)
            .attr("width", (d: Models.IAvailsTimelineGroupRightset) => this.timeScale(this.toEndDate(d.endDate)) - this.timeScale(this.toStartDate(d.startDate)))
            .attr("transform",
                function (d: Models.IAvailsTimelineGroupRightset) {
                    var selection = d3.select(this); // this is the contextually bound this <rect />
                    var assetData = <Models.IAvailsTimelineAssetsRightsGroup>d3.select(selection.node().parentNode).datum();  // grab parent data
                    var level = self.levelDictionary[assetData.assetIDsHash][d.rightsetID];
                    return "translate(" + self.timeScale(self.toStartDate(d.startDate)) + "," + self.heightOfRowShadow(level) + ")";
                })
            .each(function (d: Models.IAvailsTimelineGroupRightset) {
                var selection = d3.select(this); // this is the contextually bound this <rect />
                selection.classed("template-" + d.templateID, true);
                selection.classed("template-group-" + d.templateGroupID, true);
                if (d.dealID < 0) {
                    selection.classed("template-provisional", true);
                }
                if (!_.isEmpty(d.templateVisualization)) {
                    selection.style("fill", d.templateVisualization, "important");
                }
            });

        var overrrunBoxsData = rowGData.select("g.asset-data g.asset-boxes")
            .attr("transform", "translate(0," + (this.barHeight / 2 + this.summaryBarHeight) + ")")
            .selectAll("rect.overrun")
            .data((d: Models.IAvailsTimelineAssetsRightsGroup) => d.rightsets, (d: Models.IAvailsTimelineGroupRightset) => d.rightsetID.toString());

        /* ENTER append rect.box */
        overrrunBoxsData.enter()
            .append("rect")
            .classed("overrun", true);
        //.attr("style",(d: Models.IAvailSearchAssetRightSet) => "fill:" + this.colorScale(d.rightSetTemplateID));

        /* EXIT remove rect.box */
        overrrunBoxsData.exit().remove();

        /* UPDATE adjust height/position of rect.box */
        overrrunBoxsData
            .attr("visibility", d => d.overrunStartDate != null ? "" : "hidden")
            .attr("height", this.barHeight - 1)
            .attr("width", (d: Models.IAvailsTimelineGroupRightset) => this.timeScale(this.toEndDate(d.endDate)) - this.timeScale(this.toStartDate(d.overrunStartDate)))
            .attr("transform",
                function (d: Models.IAvailsTimelineGroupRightset) {
                    var selection = d3.select(this); // this is the contextually bound this <rect />
                    var assetData = <Models.IAvailsTimelineAssetsRightsGroup>d3.select(selection.node().parentNode).datum();  // grab parent data
                    var level = self.levelDictionary[assetData.assetIDsHash][d.rightsetID];
                    return "translate(" + self.timeScale(self.toStartDate(d.overrunStartDate)) + "," + (self.heightOfRowShadow(level) + 1) + ")";
                });

        /* UPDATE title foreignObjects for rights, data unique by rightSetID */
        var rightTitlesData = rowGData.select("g.asset-data g.asset-box-texts")
            .attr("transform", "translate(0," + (this.barHeight / 2 + this.summaryBarHeight) + ")")
            .selectAll(".right-title-fo")
            .data((d: Models.IAvailsTimelineAssetsRightsGroup) => d.rightsets, (d: Models.IAvailsTimelineGroupRightset) => d.rightsetID.toString());

        /* ENTER append foreignObject.right-titl-fo > div.right-title.box, set mouseover/mousemove/mouseout/click events */
        rightTitlesData.enter()
            .append("foreignObject")
            .classed("right-title-fo", true)
            .on("click", (d: Models.IAvailsTimelineGroupRightset) => {
                this.ctrl.ShowDetails(d);
                return this.OpenToolTip();
            }, true)
            .append("xhtml:div")
            .classed("right-title-box", true);

        /* EXIT remove foreignObject.right-title-fo */
        rightTitlesData.exit().remove();

        /* UPDATE adjust width/position of foreignObject.right-title-fo
         *  set text values on div.right-title-box
          */
        rightTitlesData.attr("height", this.barHeight)
            .attr("width", (d: Models.IAvailsTimelineGroupRightset) => this.timeScale(this.toEndDate(d.endDate)) - this.timeScale(this.toStartDate(d.startDate)))
            .attr("transform",
                function (d: Models.IAvailsTimelineGroupRightset) {
                    var selection = d3.select(this); // this is the contextually bound this <rect />
                    var assetData = <Models.IAvailsTimelineAssetsRightsGroup>d3.select(selection.node().parentNode).datum();  // grab parent data
                    var level = self.levelDictionary[assetData.assetIDsHash][d.rightsetID];
                    return "translate(" + self.timeScale(self.toStartDate(d.startDate)) + "," + self.heightOfRowShadow(level) + ")";
                })
            .select(".right-title-box")
            .each(function (d: Models.IAvailsTimelineGroupRightset) {
                var titleBox = d3.select(this); // this is the contextually bound this <div class="right-title-box" />

                // clear out previous content
                $(titleBox.node()).empty();

                // build a ul of the rightset data depending on controller visibility
                var ul = titleBox.append("ul").classed("list-inline", true);
                if (self.ctrl.filterModel.show.dealIDs && d.dealID > 0) {
                    ul.append("li").classed("deal-id", true).text(self.ctrl.FormatID(d.dealID));
                }
                if (self.ctrl.filterModel.show.clients && d.dealID > 0) {
                    ul.append("li").classed("deal-client", true).text(self.ctrl.clientDictionary[d.dealID]);
                }
                if (self.ctrl.filterModel.show.medias && d.dim1ValueIDs.length > 0) {
                    ul.append("li").classed("media-id", true).text(d.dim1ValueIDs.map((mediaID) => self.ctrl.mediaDictionary[mediaID]).join(", "));
                }
                if (self.ctrl.filterModel.show.territories && d.dim2ValueIDs.length > 0) {
                    ul.append("li").classed("territory-id", true).text(d.dim2ValueIDs.map((territoryID) => self.ctrl.territoryDictionary[territoryID]).join(", "));
                }
                if (self.ctrl.filterModel.show.channels && d.dim4ValueIDs.length > 0) {
                    ul.append("li").classed("channel-id", true).text(d.dim4ValueIDs.map((channelID) => self.ctrl.channelDictionary[channelID]).join(", "));
                }
                if (self.ctrl.filterModel.show.languages && d.dim3ValueIDs.length > 0) {
                    ul.append("li").classed("language-id", true).text(d.dim3ValueIDs.map((languageID) => self.ctrl.languageDictionary[languageID]).join(", "));
                }
                // set template based class
                titleBox.classed("template-" + d.templateID, true);
                titleBox.classed("template-group-" + d.templateGroupID, true);
                if (d.dealID < 0) {
                    titleBox.classed("template-provisional", true);
                }
                titleBox.classed("inactive-rightset", d.isActive === false);
                if (!_.isEmpty(d.templateVisualization)) {
                    titleBox.style("color", self.PickTextColorBasedOnBgColor(d.templateVisualization, "#f2f2f2", "#3c3d3a"), "important");
                }
            });
    }

    /*
     * Renders the header svg
     */
    RenderHeader() {

        var headerSVG = this.chartContainer.select("svg.header").attr({ width: this.width, height: this.barHeight * 4 });
        var headerDefs = headerSVG.select("defs");
        var scaleG = headerSVG.select("g.scale").attr("transform", "translate(" + this.dealMarginWidth + ", 0)");

        // make the horizontal scale line visible if not already
        var scaleHorizontalLine = scaleG.select(".scale-horizontal")
            .style("visibility", "visible")
            .attr({ x1: 0, x2: this.width, y1: 0, y2: 0 })
            .attr("transform", "translate(0," + this.barHeight + ")");

        var windowPane = scaleG.select(".window-pane")
            .attr({ x: 0, y: 0, width: this.width - this.dealMarginWidth, height: this.barHeight * 4 });

        this.RenderScale(scaleG, "header");

        this.RenderSearchWindowZone(scaleG, "header", headerDefs);

        /* caculate relative thickness of bars on each window */
        var positionSummary = (d: Models.IAvailsTimelineSummaryWindow) => {
            var total = (d.availableCount || 0) + (d.partialCount || 0) + (d.unavailableCount || 0);
            if (total == 0) {
                return [1, 0, 0];
            }

            var available = d.availableCount / total;
            var partial = d.partialCount / total;
            var unavailable = d.unavailableCount / total;
            return [available, partial, unavailable];
        };

        /* header summary bar */
        var summaryBarGsData = headerSVG.select("g.summary-bar")
            .attr("transform", "translate(" + this.dealMarginWidth + "," + this.barHeight * 2.5 + ")")
            .style("display", this.assetData.length > 1 ? "" : "none")
            .selectAll("g")
            .data(this.summaryData, (d: Models.IAvailsTimelineSummaryWindow) => d.windowStart);

        /* ENTER append g with 3 child rects */
        summaryBarGsData.enter()
            .append("g")
            .call((g) => {
                g.append("rect").classed("available", true).append("title");
                g.append("rect").classed("partial", true).append("title");
                g.append("rect").classed("unavailable", true).append("title");
            });

        /* EXIT remove g */
        summaryBarGsData.exit().remove();

        /* UPDATE adjust g position */
        summaryBarGsData
            .attr("transform", (d: Models.IAvailsTimelineSummaryWindow) => "translate(" + this.timeScale(this.toStartDate(d.windowStart)) + ",0)")
            .call((g) => {
                /* render green bars height/width/position */
                g.select("rect.available")
                    .attr("width", (d: Models.IAvailsTimelineSummaryWindow, i: number) => {
                        var x1 = this.timeScale(this.toStartDate(d.windowStart));
                        var x2 = this.timeScale(this.toEndDate(d.windowEnd));
                        return x2 - x1;
                    })
                    .attr("height", (d: Models.IAvailsTimelineSummaryWindow) => {
                        var positions = positionSummary(d);
                        return this.barHeight * positions[0];
                    })
                    .select("title")
                    .text((d: Models.IAvailsTimelineSummaryWindow) => d.windowStart + "  " + d.windowEnd);

                /* adjust yellow bars height/width/position */
                g.select("rect.partial")
                    .attr("width", (d: Models.IAvailsTimelineSummaryWindow, i: number) => {
                        var x1 = this.timeScale(this.toStartDate(d.windowStart));
                        var x2 = this.timeScale(this.toEndDate(d.windowEnd));
                        return x2 - x1;
                    })
                    .attr("height", (d: Models.IAvailsTimelineSummaryWindow) => {
                        var positions = positionSummary(d);
                        return this.barHeight * positions[1];
                    })
                    .attr("transform", (d: Models.IAvailsTimelineSummaryWindow) => {
                        var positions = positionSummary(d);
                        return "translate(0," + this.barHeight * positions[0] + ")";
                    })
                    .select("title")
                    .text((d: Models.IAvailsTimelineSummaryWindow) => d.windowStart + "  " + d.windowEnd);

                /* adjust black bars height/width/position */
                g.select("rect.unavailable")
                    .attr("width", (d: Models.IAvailsTimelineSummaryWindow, i: number) => {
                        var x1 = this.timeScale(this.toStartDate(d.windowStart));
                        var x2 = this.timeScale(this.toEndDate(d.windowEnd));
                        return x2 - x1;
                    })
                    .attr("height", (d: Models.IAvailsTimelineSummaryWindow) => {
                        var positions = positionSummary(d);
                        return this.barHeight * positions[2];
                    })
                    .attr("transform", (d: Models.IAvailsTimelineSummaryWindow) => {
                        var positions = positionSummary(d);
                        return "translate(0," + this.barHeight * (positions[0] + positions[1]) + ")";
                    })
                    .select("title")
                    .text((d: Models.IAvailsTimelineSummaryWindow) => d.windowStart + "  " + d.windowEnd);
            });

        // reorder summary bars if updated
        summaryBarGsData.order();

        // set the header info box's asset count
        headerSVG.select(".assets-info .asset-count-fo")
            .attr({ height: this.barHeight * 3, width: this.dealMarginWidth, x: 0, y: this.barHeight })
            .select(".asset-count")
            .text(() => {
                if (this.assetData.length > 0) {
                    return "Avails | " + this.ctrl.assetCount + " Titles";
                } else {
                    return "Avails | 0 Titles";
                }
            });
    }

    /*
     * Render the footer svg
     */
    RenderFooter() {

        var footerSVG = this.chartContainer.select("svg.footer").attr({ width: this.width, height: 2.5 * this.barHeight });
        var footerDefs = footerSVG.select("defs");
        var scaleG = footerSVG.select("g.scale").attr("transform", "translate(" + this.dealMarginWidth + ", 0)");
        // make the horizontal scale line visible if not already
        var scaleHorizontalLine = scaleG
            .select(".scale-horizontal")
            .style("visibility", "visible")
            .attr({ x1: 0, x2: this.width, y1: 0, y2: 0 })
            .attr("transform", "translate(0," + this.barHeight * 1.5 + ")");

        var windowPane = scaleG.select(".window-pane")
            .attr({ x: 0, y: 0, width: this.width - this.dealMarginWidth, height: 2.5 * this.barHeight });

        this.RenderScale(scaleG, "footer");
        this.RenderSearchWindowZone(scaleG, "footer", footerDefs);
    }

    RenderSearchWindowZone(g: d3.Selection<any>, section: string, defs: d3.Selection<any>) {

        var zoneWidth = this.timeScale(this.endMoment.toDate()) - this.timeScale(this.startMoment.toDate());

        var rect = g.select("rect.window-zone")
            .attr("width", zoneWidth);

        var startLine = g.select("line.window-zone-start");
        var nowLine = g.select("line.window-zone-now");
        var endLine = g.select("line.window-zone-end");

        var startMarker = g.select(".window-zone-start-marker");
        var endMarker = g.select(".window-zone-end-marker");
        var nowMarker = g.select(".window-zone-now-marker");

        var mask = defs.select(".zone-mask").attr("width", zoneWidth);

        if (section == "rows") {
            rect.attr("height", this.fullRowsHeight)
                .attr("transform", "translate(" + this.timeScale(this.startMoment.toDate()) + ",0)");
            mask.attr("height", this.fullRowsHeight);
            startLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: this.fullRowsHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(this.startMoment.toDate()) + ",0)");
            nowLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: this.fullRowsHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(moment().startOf("day").toDate()) + ",0)");
            endLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: this.fullRowsHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(this.endMoment.toDate()) + ",0)");

        } else if (section == "header") {
            var lineHeight = this.barHeight * 3;
            rect.attr("height", lineHeight)
                .attr("transform", "translate(" + this.timeScale(this.startMoment.toDate()) + "," + this.barHeight + ")");
            mask.attr("height", lineHeight);
            startLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: lineHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(this.startMoment.toDate()) + "," + this.barHeight + ")");
            nowLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: lineHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(moment().startOf("day").toDate()) + "," + this.barHeight + ")");
            endLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: lineHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(this.endMoment.toDate()) + "," + this.barHeight + ")");

            startMarker.attr("transform", "translate(" + this.timeScaleUnclamped(this.startMoment.toDate()) + "," + this.barHeight + ")");
            nowMarker.attr("transform", "translate(" + this.timeScaleUnclamped(moment().startOf("day").toDate()) + "," + this.barHeight + ")");
            endMarker.attr("transform", "translate(" + this.timeScaleUnclamped(this.endMoment.toDate()) + "," + this.barHeight + ")");
        } else if (section == "footer") {

            var lineHeight = this.barHeight * 1.5;

            rect.attr("height", lineHeight)
                .attr("transform", "translate(" + this.timeScale(this.startMoment.toDate()) + ",0)");
            mask.attr("height", lineHeight);
            startLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: lineHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(this.startMoment.toDate()) + ",0)");
            nowLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: lineHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(moment().startOf("day").toDate()) + ",0)");
            endLine
                .attr({ x1: 0, y1: 0, x2: 0, y2: lineHeight })
                .attr("transform", "translate(" + this.timeScaleUnclamped(this.endMoment.toDate()) + ",0)");

            startMarker.attr("transform", "translate(" + this.timeScaleUnclamped(this.startMoment.toDate()) + "," + lineHeight + ")");
            nowMarker.attr("transform", "translate(" + this.timeScaleUnclamped(moment().startOf("day").toDate()) + "," + lineHeight + ")");
            endMarker.attr("transform", "translate(" + this.timeScaleUnclamped(this.endMoment.toDate()) + "," + lineHeight + ")");
        }
    }

    RenderScale(scaleG: d3.Selection<any>, section: string) {

        var isPrimaryTick = (d: any) => {
            var thisMoment = moment(d);
            return (this.scaleLevel == 1 && thisMoment.month() == 0) || (this.scaleLevel == 2 && thisMoment.date() == 1);
        };


        /* setup lines */
        var tickLinesData = scaleG
            .select("g.ticks")
            .selectAll("line.tick.line")
            .data(this.secondaryTicks.filter((d, i) => isPrimaryTick(d) || this.showSecondaryTicks));

        /* ENTER append line.tick*/
        tickLinesData.enter()
            .append("line");

        /* EXIT remove line.tick */
        tickLinesData.exit().remove();

        /* UPDATE adjust class based on year/month demarcation, length/position */
        tickLinesData
            .attr("class", (d) => {
                if (isPrimaryTick(d)) {
                    return "tick line year";
                } else {
                    return "tick line month";
                }
            })
            .attr({ x1: 0, x2: 0 })
            .attr("transform", d => "translate(" + this.timeScale(d) + ",0)");

        switch (section) {
            case "header":
                tickLinesData
                    .attr("y2", this.barHeight * 4)
                    .attr("y1", d => isPrimaryTick(d) ? 0 : this.barHeight);
                break;
            case "rows":
                tickLinesData.attr({ y1: 0, y2: this.fullRowsHeight });
                break;
            case "footer":
                tickLinesData
                    .attr("y2", 0)
                    .attr("y1", d => isPrimaryTick(d) ? this.barHeight * 2.5 : this.barHeight * 1.5);
                break;
            default:
                break;
        }


        if (section == "header" || section == "footer") {

            var ticksTextG = scaleG.select(".tick-texts");

            /* year scale text */
            var yearTextData = ticksTextG
                .selectAll("text.tick.text.year")
                .data(this.primaryTicks);

            /* ENTER append text.tick */
            yearTextData.enter()
                .append("text")
                .classed("tick text year", true);

            /* EXIT remove text.tick */
            yearTextData.exit().remove();

            /* UPDATE set text/position of text */
            yearTextData.text((d) => {
                if (this.scaleLevel == 1) {
                    return d3.time.format("%Y")(d);
                } else if (this.scaleLevel == 2) {
                    return d3.time.format("%b %Y")(d);
                }
            })
                .attr("text-anchor", "middle")
                .attr("dy", "1.25em")
                .attr("x", (d, i) => {
                    var x1 = this.timeScale(d);
                    if (i == 0) {
                        x1 = 0;
                    }
                    var x2 = this.width - this.dealMarginWidth;
                    if (i + 1 < this.primaryTicks.length) {
                        x2 = this.timeScale(this.primaryTicks[i + 1]);
                    }
                    return (x2 + x1) / 2;
                });

            /* month scale text */
            var monthTextData = ticksTextG
                .selectAll("text.tick.text.month")
                .data(this.secondaryTicks.filter((d, i) => this.showSecondaryTicks));

            /* ENTER appent text.tick */
            monthTextData.enter()
                .append("text")
                .classed("tick text month", true);

            /* EXIT remove text.tick */
            monthTextData.exit().remove();

            /* UPDATE set text/position of text */
            monthTextData.text((d) => {
                if (this.scaleLevel == 1) {
                    return d3.time.format("%b")(d);
                } else if (this.scaleLevel == 2) {
                    return d3.time.format("%d")(d)
                }
            })
                .attr("text-anchor", "middle")
                .attr("dy", "1.25em")
                .attr("x", (d, i) => {
                    var x1 = this.timeScale(d);
                    if (i == 0) {
                        x1 = 0;
                    }
                    var x2 = this.width - this.dealMarginWidth;
                    if (i + 1 < this.secondaryTicks.length) {
                        x2 = this.timeScale(this.secondaryTicks[i + 1]);
                    }
                    return (x2 + x1) / 2;
                });


            switch (section) {
                case "header":
                    yearTextData.attr("y", 0);
                    monthTextData.attr("y", this.barHeight);
                    break;
                case "footer":
                    yearTextData.attr("y", (1.5 * this.barHeight));
                    monthTextData.attr("y", (0.5 * this.barHeight));
                    break;
                default:
                    break;
            }
        }
    }

    OpenToolTip() {
        return this.SetToolTipPosition().style("visibility", "visible");
    }

    SetToolTipPosition() {
        var maxHeight = $(window).height() - 20 - this.tooltipPosition.top;
        return this.tooltip.style("top", this.tooltipPosition.top + "px").style("left", this.tooltipPosition.left + "px").style("max-height", maxHeight + "px");
    }

    CloseToolTip() {
        return this.tooltip.style("visibility", "hidden");

    }

    private PickTextColorBasedOnBgColor(bgColor, lightColor, darkColor) {
        var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
        var r = parseInt(color.substring(0, 2), 16); // hexToR
        var g = parseInt(color.substring(2, 4), 16); // hexToG
        var b = parseInt(color.substring(4, 6), 16); // hexToB
        var uicolors = [r / 255, g / 255, b / 255];
        var c = uicolors.map((col) => {
            if (col <= 0.03928) {
                return col / 12.92;
            }
            return Math.pow((col + 0.055) / 1.055, 2.4);
        });
        var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
        return (L > 0.179) ? darkColor : lightColor;
    }

}

